import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import MobileBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_375x550.png";
import DesktopBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_1920x450.png";

export const cincinnatireds_321tuesday_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "cincinnatireds_321tuesday_sandbox",
  TEAM_FULL_NAME: "Cincinnati Reds",
  BROWSER_TITLE: "3-2-1 Tuesday Ballpark Pass",
  CLIENT_ID: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C6011F",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    ACCOUNT_MANAGER_URL:
      "https://mlb.tickets.com/?orgid=31427&agency=RDMT_MYTIXX&_gl=1*1enisz*_gcl_aw*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_dc*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_au*MTY3Mzk0MDU4NC4xNzQwNzcyODM2*_ga*OTQxNTUzODcxLjE3NDA0MTY2MDM.*_ga_N8YFCZLYSZ*MTc0MTIxNTI2NC40LjEuMTc0MTIxNTQ0NC41OS4wLjc3MTg5Nzk2OQ..#/auth/login?fullret=%2Fticketmanagement%2F%3Forgid%3D31427%26agency%3DRDMT_MYTIXX%26_gl%3D1*1enisz*_gcl_aw*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_dc*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_au*MTY3Mzk0MDU4NC4xNzQwNzcyODM2*_ga*OTQxNTUzODcxLjE3NDA0MTY2MDM.*_ga_N8YFCZLYSZ*MTc0MTIxNTI2NC40LjEuMTc0MTIxNTQ0NC41OS4wLjc3MTg5Nzk2OQ..%23%2F",

    FOOTER: {
      LINKS: FooterLinks,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/CIN-3.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/BallparkPerspective3.JPG",
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBanner.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBanner.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
